/**
 * branding.js - Configuración de branding de la aplicación
 * 
 * Este archivo centraliza todas las constantes relacionadas con
 * el branding de la aplicación (nombres, logos, footers, etc.)
 * 
 * Para cambiar el pie de página en toda la aplicación y documentos,
 * simplemente modifica la constante FOOTER_TEXT.
 */

const APP_BRANDING = {
    // Texto del pie de página que aparece en todas las pantallas y PDFs
    FOOTER_TEXT: 'SSWork',

    // Nombre completo de la aplicación
    APP_NAME: 'Detectimáticas 1º',

    // Año/versión (opcional, para uso futuro)
    VERSION: '1.0'
};

// Hacer disponible globalmente
if (typeof window !== 'undefined') {
    window.APP_BRANDING = APP_BRANDING;
}

// Para Node.js / módulos
if (typeof module !== 'undefined' && module.exports) {
    module.exports = APP_BRANDING;
}

console.log('🏷️ branding.js cargado - Configuración de branding disponible');
